import { render } from "./Fingers.vue?vue&type=template&id=f9cdf566"
import script from "./Fingers.vue?vue&type=script&lang=js"
export * from "./Fingers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__